<template>
	<v-menu
        offset-y						
        :return-value.sync 		= "inputField[keyField]"    	
        :ref 					= "reference"
        v-model 				= "menu"
        :close-on-content-click = "false"
        transition 				= "scale-transition"
        max-width 				= "290px"
        min-width 				= "290px"
    >
        <template v-slot:activator="{ on, attrs }">
          	<v-text-field
	            dense
	            outlined
	            readonly
	            hide-details
	            v-model 	 		= "inputField[keyField]"
	            :label 		 		= "$ml.get(text)"
	            prepend-inner-icon 	= "mdi-clock-time-four-outline"
	            v-bind 		 		= "attrs"
	            v-on 		 		= "on"
          	></v-text-field>
        </template>	        
        <v-time-picker
	        no-title
	        scrollable
	        v-if 			= "menu"
	        v-model 		= "inputField[keyField]"
	        format 			= "24hr"
	        @click:minute 	= "saveTime(inputField[keyField])"
        >
	        <!-- @input 		 	= "renderDate()"  -->
        	<v-spacer></v-spacer>
	        <v-btn
	            text
	            color="primary"
	            @click="menu=false"
	        >
	            {{$ml.get('cancel')}}
	        </v-btn>
	          <v-btn
	            text
	            color="primary"
	            @click="saveTime()"
	        >
	            OK
	        </v-btn>
        </v-time-picker>
    </v-menu>
</template>
<script type="text/javascript">
	export default{
		name: "MenuTime",
		props:{
			inputField : { type : Object, required: true } ,
			keyField : { type : String, required: true },
			text : { type : String },
			placeholder : { type : String },			
			reference : { type : String, default : 'timePicker'},
		},
		data: () => ({
			menu 		 	: false,
			picker 		 	: [], 	
		}),
		methods:{
			renderDate(){
				if (this.inputField && this.inputField[this.keyField]) {										
					this.cancelDate();				
				}else{
					console.warn("Not receive info item to send date / time : ", this.inputField[this.keyField]);
				}				
			}, // render search

			cancelDate(){
				this.menu=false
			},
			saveTime(item){	 				
				if (this.inputField && this.inputField[this.keyField] && this.$refs[this.reference]) {					
	 				this.$refs[this.reference].save(this.inputField[this.keyField]); // [0]
	 				this.inputField[this.keyField]=item;
				} 				
			},
		},
	}
</script>